import React, {useState, setGlobal, getGlobal, useEffect} from 'reactn';
import { Radio, Checkbox, Button, Skeleton, Switch, notification, Popover, Tabs} from 'antd';
import {useParams} from 'react-router-dom';
import { useFirestore } from 'reactfire';

const Pain = (props) => {
    
    const [isPain, setPain] = useState('No');
    let { appointmentId } = useParams();
    const [popup, setPopup] = useState(false);
    const firestore = useFirestore();

    const [state, setState] = useState();
    const [loading, setLoading] = useState(false);
    const [loadingBtn, setLoadingBtn] = useState(false);
    
    const getSelectedFields = (event) => {
        setState({
            ...state,
            [event.target.name] : event.target.value
        });
    }

    useEffect(() => {
        // if (!getGlobal().hasFetchedChiefComplaints) {
        // }
        getCurrentCCLocation();
    }, [props]);

    const getCurrentCCLocation = () => {

        let records = [];
        setLoading(true);
        firestore.collection("ChiefComplaints").where("appointment_id", "==", appointmentId).get()
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                records.push({data: doc.data(), id: doc.id});
            });
        }).finally(() => {
            if (records.length> 0 && records[0].data && records[0].data.ChiefComplaints_location && records[0].data.ChiefComplaints_location.OralCavity && records[0].data.ChiefComplaints_location.OralCavity.Pain) {
                let thisObj = records[0].data.ChiefComplaints_location.OralCavity.Pain;
                setState(thisObj ? thisObj : {});
                setPain(thisObj ? 'Yes' : 'No');
                if (!thisObj) {
                    assignDefaultValues();
                }
            } else {
                assignDefaultValues();
            }

            setLoading(false);
        });

    }

    const assignDefaultValues = () => {
        if (!state) {
            assignDefaultValuesAnyways();
        }
    }

    const assignDefaultValuesAnyways = () => {
        setState({
            'Duration' : '< week',
            'Onset' : 'Sudden',
            'Progression' : 'Not Progressive',
            'Severity' : 'Mild',
            'Aggravating Factors' : 'Not Known',
            'Relieving Factors' : 'Not Known',
            'Causative Factors' : 'Not Known',
            'Effects' : 'No Effect',
            'Assocaited Symptoms' : 'No Assocaited Symptoms',
            'Personal Habits' : 'Healthy Life Style',
            'Risk Factors' : 'Not Known',
            'Treatment Taken' : 'No',
            'Visual Analog Scale' : '6'

        });
    }

    const getCheckBoxONChange = (value, target) => {
        setState({
            ...state,
            [target] : value
        });
    }

    const saveTheForm = () => {
        setLoadingBtn(true);
        let previosuValues = {};
        if (getGlobal().ChiefComplaints_location) {
            previosuValues = {...getGlobal().ChiefComplaints_location};
        } else {
            previosuValues = {}
        }
        let objectToSave = {
            ...previosuValues,
            'OralCavity': {
                ...previosuValues.OralCavity,
                'Pain' : {'isPain': isPain, ...state}
            }
        }


        if (getGlobal().ChiefComplaints_location_id) {
            firestore.collection('ChiefComplaints').doc(getGlobal().ChiefComplaints_location_id).update({
                ChiefComplaints_location: objectToSave,
            }).then(() => {
                notification.open({
                    message: 'Record Successfully Updated',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).catch(() => {
                notification.open({
                    message: 'An Error Occured',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).finally(() => {
                props.hasSaved();
                setLoadingBtn(false);
            });
        } else {
            firestore.collection('ChiefComplaints').add({
                patient: firestore.collection("patients").doc(getGlobal().patientID),
                appointment: firestore.collection("appointments").doc(getGlobal().appointmentId),
                appointment_id: getGlobal().appointmentId,
                date: new Date(),
                ChiefComplaints_location: objectToSave,
            }).then(() => {
                notification.open({
                    message: 'Record Successfully Added',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).catch(() => {
                notification.open({
                    message: 'An Error Occured',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).finally(() => {
                props.hasSaved();
                setLoadingBtn(false);
            });
        }
  

        
    }

    const deletePain = () => {

        let previosuValues = {};
        if (getGlobal().ChiefComplaints_location) {
            previosuValues = {...getGlobal().ChiefComplaints_location};
        } else {
            previosuValues = {}
        }
        let objectToDelete = {
            ...previosuValues,
            'OralCavity': {
                ...previosuValues.OralCavity,
                'Pain' : null
            }
        }
        firestore.collection('ChiefComplaints').doc(getGlobal().ChiefComplaints_location_id).update({
            ChiefComplaints_location: objectToDelete,
            
        }).then(() => {
            notification.open({
                message: 'Record Successfully Delete',
                // icon: <DeleteOutlined style={{ color: '#f00' }} />,
            });
            setGlobal({ChiefComplaints_location: {...getGlobal().ChiefComplaints_location.OralCavity, Pain: null}})
            setPopup(!popup)
            props.hasSaved();
            assignDefaultValuesAnyways();
        }).catch(() => {
            notification.open({
                message: 'An Error Occured',
                // icon: <DeleteOutlined style={{ color: '#f00' }} />,
            });
        });


      
    }




    const PainSelect = (event) => {
        setPain(event.target.value);
    }



    return (
        <div>
            <React.Fragment>
            {loading ? <Skeleton active /> : <>
            <Radio.Group value={isPain} onChange={PainSelect} buttonStyle="solid" size="large" style={{marginTop: '20px'}}>
                    <Radio.Button value={'Yes'}>Yes</Radio.Button>
                    
                    <Popover
                        content={<a onClick={deletePain}>Delete</a>}
                        title="Are you sure you want to delete All Record of Pain?"
                        trigger="click"
                        visible={popup}
                        onVisibleChange={() => {
                            if(getGlobal().ChiefComplaints_location.OralCavity && getGlobal().ChiefComplaints_location.OralCavity.Pain){setPopup(!popup)}
                        }}
                    >
                        {/* <DeleteOutlined /> */}
                        <Radio.Button value={'No'}>No</Radio.Button>

                        
                    
                    </Popover>

                </Radio.Group>
               
               {isPain === 'Yes' && <Button className="SaveFormButton" loading={loadingBtn} style={{float: 'right'}} onClick={saveTheForm} type="primary">Save</Button>}
  
               {isPain === 'Yes' ? 

                    <ul className='showFieldsTable'>
                        <li><span>Duration</span>
                            <Radio.Group name="Duration" value={state && state['Duration']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'1 day'}>1 Day</Radio.Button>
                                <Radio.Button value={'< week'}>&lt; Week</Radio.Button>
                                <Radio.Button value={'< 2 week'}>&lt; 2 Weeks</Radio.Button>
                                <Radio.Button value={'< month'}>&lt; Month</Radio.Button>
                                <Radio.Button value={'< 3 months'}>&lt; 3 Months</Radio.Button>
                                <Radio.Button value={'< 6 months'}>&lt; 6 Months</Radio.Button>
                                <Radio.Button value={'< year'}>&lt; Year</Radio.Button>
                                <Radio.Button value={'> year'}>&gt; Year</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Onset</span>
                            <Radio.Group name="Onset" value={state && state['Onset']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Sudden'}>Sudden</Radio.Button>
                                <Radio.Button value={'Gradual'}>Gradual</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span style={{fontSize:'18px'}}>Site</span>
                            <ul className='nestedUl'>
                                <li><span>Right Site</span>
                                    <Checkbox.Group name="Right Site" value={state && state['Right Site']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Right Site')} size="large">
                                        <Checkbox value="Mouth" style={{ lineHeight: '32px' }}>
                                        Mouth
                                        </Checkbox>
                                        <Checkbox value="Cheek" style={{ lineHeight: '32px' }}>
                                        Cheek
                                        </Checkbox>
                                        <Checkbox value="Buccal Mucosa" style={{ lineHeight: '32px' }}>
                                        Buccal Mucosa
                                        </Checkbox>
                                        <Checkbox value="palate" style={{ lineHeight: '32px' }}>
                                        palate
                                        </Checkbox>
                                        <Checkbox value="Tongue" style={{ lineHeight: '32px' }}>
                                        Tongue
                                        </Checkbox>
                                        <Checkbox value="Tonsil" style={{ lineHeight: '32px' }}>
                                        Tonsil
                                        </Checkbox>
                                        <Checkbox value="Post Pharyngeal wall" style={{ lineHeight: '32px' }}>
                                        Post Pharyngeal wall
                                        </Checkbox>
                                        <Checkbox value="Oropharynx" style={{ lineHeight: '32px' }}>
                                        Oropharynx
                                        </Checkbox>
                                        <Checkbox value="other" style={{ lineHeight: '32px' }}>
                                        other
                                        </Checkbox>
                                    </Checkbox.Group>
                                </li>
                                <li><span>Left Site</span>
                                    <Checkbox.Group name="Left Site" value={state && state['Left Site']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Left Site')} size="large">
                                        <Checkbox value="Mouth" style={{ lineHeight: '32px' }}>
                                        Mouth
                                        </Checkbox>
                                        <Checkbox value="Cheek" style={{ lineHeight: '32px' }}>
                                        Cheek
                                        </Checkbox>
                                        <Checkbox value="Buccal Mucosa" style={{ lineHeight: '32px' }}>
                                        Buccal Mucosa
                                        </Checkbox>
                                        <Checkbox value="palate" style={{ lineHeight: '32px' }}>
                                        palate
                                        </Checkbox>
                                        <Checkbox value="Tongue" style={{ lineHeight: '32px' }}>
                                        Tongue
                                        </Checkbox>
                                        <Checkbox value="Tonsil" style={{ lineHeight: '32px' }}>
                                        Tonsil
                                        </Checkbox>
                                        <Checkbox value="Post Pharyngeal wall" style={{ lineHeight: '32px' }}>
                                        Post Pharyngeal wall
                                        </Checkbox>
                                        <Checkbox value="Oropharynx" style={{ lineHeight: '32px' }}>
                                        Oropharynx
                                        </Checkbox>
                                        <Checkbox value="other" style={{ lineHeight: '32px' }}>
                                        other
                                        </Checkbox>
                                    </Checkbox.Group>
                                </li>
                                <li><span>Bilateral Site</span>
                                    <Checkbox.Group name="Bilateral Site" value={state && state['Bilateral Site']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Bilateral Site')} size="large">
                                        <Checkbox value="Mouth" style={{ lineHeight: '32px' }}>
                                        Mouth
                                        </Checkbox>
                                        <Checkbox value="Cheek" style={{ lineHeight: '32px' }}>
                                        Cheek
                                        </Checkbox>
                                        <Checkbox value="Buccal Mucosa" style={{ lineHeight: '32px' }}>
                                        Buccal Mucosa
                                        </Checkbox>
                                        <Checkbox value="palate" style={{ lineHeight: '32px' }}>
                                        palate
                                        </Checkbox>
                                        <Checkbox value="Tongue" style={{ lineHeight: '32px' }}>
                                        Tongue
                                        </Checkbox>
                                        <Checkbox value="Tonsil" style={{ lineHeight: '32px' }}>
                                        Tonsil
                                        </Checkbox>
                                        <Checkbox value="Post Pharyngeal wall" style={{ lineHeight: '32px' }}>
                                        Post Pharyngeal wall
                                        </Checkbox>
                                        <Checkbox value="Oropharynx" style={{ lineHeight: '32px' }}>
                                        Oropharynx
                                        </Checkbox>
                                        <Checkbox value="other" style={{ lineHeight: '32px' }}>
                                        other
                                        </Checkbox>
                                    </Checkbox.Group>
                                </li>
                           
                            </ul>
                        </li>
                       
                        <li><span>Progression</span>
                            <Radio.Group name="Progression" value={state && state['Progression']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Not Progressive'}>Not Progressive</Radio.Button>
                                <Radio.Button value={'Slow Progressive'}>Slow Progressive</Radio.Button>
                                <Radio.Button value={'Fast Progressive'}>Fast Progressive</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Severity</span>
                            <Radio.Group name="Severity" value={state && state['Severity']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Mild'}>Mild</Radio.Button>
                                <Radio.Button value={'Moderate'}>Moderate</Radio.Button>
                                <Radio.Button value={'Severe'}>Severe</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Aggravating Factors</span>
                            <Checkbox.Group name="Aggravating Factors" value={state && state['Aggravating Factors']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Aggravating Factors')} size="large">
                                <Checkbox value="Not Known" style={{ lineHeight: '32px' }}>
                                Not Known
                                </Checkbox>
                                <Checkbox value="Spicy Foods" style={{ lineHeight: '32px' }}>
                                Spicy foods
                                </Checkbox>
                                <Checkbox value="Chewing Food" style={{ lineHeight: '32px' }}>
                                Chewing Food
                                </Checkbox>
                                <Checkbox value="Drinks" style={{ lineHeight: '32px' }}>
                                Drinks
                                </Checkbox>
                                <Checkbox value="other" style={{ lineHeight: '32px' }}>
                                other
                                </Checkbox>
                            </Checkbox.Group>
                       

                        </li>
                        <li><span>Relieving Factors</span>
                            <Checkbox.Group name="Relieving Factors" value={state && state['Relieving Factors']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Relieving Factors')} size="large">
                                <Checkbox value="Not Known" style={{ lineHeight: '32px' }}>
                                Not Known
                                </Checkbox>
                                <Checkbox value="Self Remitting" style={{ lineHeight: '32px' }}>
                                Self Remitting
                                </Checkbox>
                                <Checkbox value="Medication" style={{ lineHeight: '32px' }}>
                                Medication
                                </Checkbox>
                                <Checkbox value="Certain Foods" style={{ lineHeight: '32px' }}>
                                Certain Foods
                                </Checkbox>
                                <Checkbox value="other" style={{ lineHeight: '32px' }}>
                                other
                                </Checkbox>
                            </Checkbox.Group>
                        </li>
                        <li><span>Causative Factors</span>
                            <Checkbox.Group name="Causative Factors" value={state && state['Causative Factors']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Causative Factors')} size="large">
                            <Checkbox value="Not Known" style={{ lineHeight: '32px' }}>
                                Not Known
                                </Checkbox>
                                <Checkbox value="Foreign body" style={{ lineHeight: '32px' }}>
                                Foreign body
                                </Checkbox>
                                <Checkbox value="Trauma" style={{ lineHeight: '32px' }}>
                                Trauma
                                </Checkbox>
                                <Checkbox value="Ill fitting Denture" style={{ lineHeight: '32px' }}>
                                Ill fitting Denture
                                </Checkbox>
                                <Checkbox value="Jagged Tooth" style={{ lineHeight: '32px' }}>
                                Jagged Tooth
                                </Checkbox>
                                <Checkbox value="Corrosive Intake" style={{ lineHeight: '32px' }}>
                                Corrosive Intake
                                </Checkbox>
                                <Checkbox value="Pan Chewing" style={{ lineHeight: '32px' }}>
                                Pan Chewing
                                </Checkbox>
                                <Checkbox value="Smoking" style={{ lineHeight: '32px' }}>
                                Smoking
                                </Checkbox>
                                <Checkbox value="Other" style={{ lineHeight: '32px' }}>
                                Other
                                </Checkbox>
                                
                            </Checkbox.Group>
                        </li>
                        <li><span>Effects</span>
                            <Checkbox.Group name="Effects" value={state && state['Effects']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Effects')} size="large">
                                <Checkbox value="No Effect" style={{ lineHeight: '32px' }}>
                                No Effect
                                </Checkbox>
                                <Checkbox value="Restricted mouth opening" style={{ lineHeight: '32px' }}>
                                Restricted mouth opening
                                </Checkbox>
                                <Checkbox value="Restricted movements of tongue" style={{ lineHeight: '32px' }}>
                                Restricted movements of tongue
                                </Checkbox>
                                <Checkbox value="Difficulty of chewing" style={{ lineHeight: '32px' }}>
                                Difficulty of chewing
                                </Checkbox>
                                <Checkbox value="Difficulty of articulation" style={{ lineHeight: '32px' }}>
                                Difficulty of articulation
                                </Checkbox>
                                <Checkbox value="Difficulty of swallowing" style={{ lineHeight: '32px' }}>
                                Difficulty of swallowing
                                </Checkbox>
                                <Checkbox value="Other" style={{ lineHeight: '32px' }}>
                                Other
                                </Checkbox>
                                
                            </Checkbox.Group>
                        </li>
                        <li><span>Assocaited Symptoms</span>
                            <Checkbox.Group name="Assocaited Symptoms" value={state && state['Assocaited Symptoms']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Assocaited Symptoms')} size="large">
                                <Checkbox value="No Assocaited Symptoms" style={{ lineHeight: '32px' }}>
                                No Assocaited Symptoms
                                </Checkbox>
                                <Checkbox value="Fever" style={{ lineHeight: '32px' }}>
                                Fever
                                </Checkbox>
                                <Checkbox value="Anorexia" style={{ lineHeight: '32px' }}>
                                Anorexia
                                </Checkbox>
                                <Checkbox value="Neck swelling" style={{ lineHeight: '32px' }}>
                                Neck swelling
                                </Checkbox>
                                <Checkbox value="Weight Loss" style={{ lineHeight: '32px' }}>
                                Weight Loss
                                </Checkbox>
                                <Checkbox value="Mouth Genital or Oral Ulcer" style={{ lineHeight: '32px' }}>
                                Mouth Genital or Oral Ulcer
                                </Checkbox>
                                <Checkbox value="Any other skin lesion" style={{ lineHeight: '32px' }}>
                                Any other skin lesion
                                </Checkbox>
                                <Checkbox value="Hoarseness" style={{ lineHeight: '32px' }}>
                                Hoarseness
                                </Checkbox>
                                <Checkbox value="Noisy Breathing" style={{ lineHeight: '32px' }}>
                                Noisy Breathing
                                </Checkbox>
                                <Checkbox value="Cough" style={{ lineHeight: '32px' }}>
                                Cough
                                </Checkbox>
                                <Checkbox value="Haemoptysis" style={{ lineHeight: '32px' }}>
                                Haemoptysis
                                </Checkbox>
                                <Checkbox value="Haematemesis" style={{ lineHeight: '32px' }}>
                                Haematemesis
                                </Checkbox>
                                <Checkbox value="Nasal Regurgitation" style={{ lineHeight: '32px' }}>
                                Nasal Regurgitation
                                </Checkbox>
                                <Checkbox value="Ear Ache" style={{ lineHeight: '32px' }}>
                                Ear Ache
                                </Checkbox>
                                <Checkbox value="Headache" style={{ lineHeight: '32px' }}>
                                Headache
                                </Checkbox>
                                <Checkbox value="Facial Pains" style={{ lineHeight: '32px' }}>
                                Facial Pains
                                </Checkbox>
                                <Checkbox value="Numbness around Face" style={{ lineHeight: '32px' }}>
                                Numbness around Face
                                </Checkbox>
                                <Checkbox value="Night sweats" style={{ lineHeight: '32px' }}>
                                Night sweats
                                </Checkbox>
                                <Checkbox value="other" style={{ lineHeight: '32px' }}>
                                other
                                </Checkbox>
                            </Checkbox.Group>
                        </li>
                        <li><span>Personal Habits</span>
                            <Checkbox.Group name="Personal Habits" value={state && state['Personal Habits']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Personal Habits')} size="large">
                                <Checkbox value="Healthy Life Style" style={{ lineHeight: '32px' }}>
                                Healthy Life Style
                                </Checkbox>
                                <Checkbox value="Fond of spicy food" style={{ lineHeight: '32px' }}>
                                Fond of spicy food
                                </Checkbox>
                                <Checkbox value="Smoker" style={{ lineHeight: '32px' }}>
                                Smoker
                                </Checkbox>
                                <Checkbox value="Pan/Beetle nut/Chalia Addict" style={{ lineHeight: '32px' }}>
                                Pan/Beetle nut/Chalia Addict
                                </Checkbox>
                                <Checkbox value="Alcohol Drinker" style={{ lineHeight: '32px' }}>
                                Alcohol Drinker
                                </Checkbox>
                                
                            </Checkbox.Group>
                        </li>
                        <li><span>Risk Factors</span>
                            <Checkbox.Group name="Risk Factors" value={state && state['Risk Factors']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Risk Factors')} size="large">
                                <Checkbox value="Not Known" style={{ lineHeight: '32px' }}>
                                Not Known
                                </Checkbox>
                                <Checkbox value="Radiation Exposure" style={{ lineHeight: '32px' }}>
                                Radiation Exposure
                                </Checkbox>
                                <Checkbox value="Other" style={{ lineHeight: '32px' }}>
                                Other
                                </Checkbox>
                            </Checkbox.Group>
                        </li>
                        
                        <li><span>Treatment Taken</span>
                            <Checkbox.Group name="Treatment Taken" value={state && state['Treatment Taken']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Treatment Taken')} size="large">
                                <Checkbox value="No" style={{ lineHeight: '32px' }}>
                                No
                                </Checkbox>
                                <Checkbox value="Medication" style={{ lineHeight: '32px' }}>
                                Medication
                                </Checkbox>
                                <Checkbox value="Surgery" style={{ lineHeight: '32px' }}>
                                Surgery
                                </Checkbox>
                                <Checkbox value="Local Application" style={{ lineHeight: '32px' }}>
                                Local Application
                                </Checkbox>
                                <Checkbox value="Other/ Details if Available" style={{ lineHeight: '32px' }}>
                                Other/ Details if Available
                                </Checkbox>
                            </Checkbox.Group>
                        </li>
                        <li><span>Visual Analog Scale</span>
                            <Radio.Group name="Visual Analog Scale" value={state && state['Visual Analog Scale']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'0'}>0</Radio.Button>
                                <Radio.Button value={'1'}>1</Radio.Button>
                                <Radio.Button value={'2'}>2</Radio.Button>
                                <Radio.Button value={'3'}>3</Radio.Button>
                                <Radio.Button value={'4'}>4</Radio.Button>
                                <Radio.Button value={'5'}>5</Radio.Button>
                                <Radio.Button value={'6'}>6</Radio.Button>
                                <Radio.Button value={'7'}>7</Radio.Button>
                                <Radio.Button value={'8'}>8</Radio.Button>
                                <Radio.Button value={'9'}>9</Radio.Button>
                                <Radio.Button value={'10'}>10</Radio.Button>
                            </Radio.Group>
                        </li>
                        <Button className="SaveFormButton" loading={loadingBtn} onClick={saveTheForm} type="primary">Save</Button>
                    </ul>

                    
                : ''}
                </>}
            </React.Fragment>
 
        </div>
    );
}

export default Pain;
